// Central API helper: base URL, auth token, and an authenticated fetch wrapper.
// Override at build time with REACT_APP_API_BASE (e.g. https://api.your-domain.ee).
export const API_BASE =
  process.env.REACT_APP_API_BASE || "http://94.237.118.249:8000";

const TOKEN_KEY = "bfms_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

// Authenticated fetch: attaches the Bearer token and, on 401, clears the token
// and reloads back to the login screen.
export async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (res.status === 401) {
    clearToken();
    window.location.reload();
    throw new Error("Unauthorized");
  }
  return res;
}

// Role helpers — mirrors the backend hierarchy (user < manager < admin).
export const ROLE_LEVELS = { user: 1, manager: 2, admin: 3 };

export function hasRole(account, minimum) {
  if (!account) return false;
  return (ROLE_LEVELS[account.role] || 0) >= (ROLE_LEVELS[minimum] || 99);
}

// Login uses a plain fetch (no token yet) and stores the returned token.
export async function login(username, password) {
  const res = await fetch(`${API_BASE}/api/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Sisselogimine ebaõnnestus");
  }

  const data = await res.json();
  setToken(data.access_token);
  return data;
}
